import { Building2, Users, Award, Scale } from 'lucide-react'

export default function UseCasesSection() {
  const cases = [
    {
      icon: Building2,
      title: 'Tổ chức giải đấu',
      description: 'Lập kế hoạch, đăng ký, bốc thăm, lên lịch và theo dõi kết quả — tất cả trong một nền tảng.'
    },
    {
      icon: Users,
      title: 'Quản lý câu lạc bộ',
      description: 'Quản lý thành viên, thu phí, lịch tập và giao tiếp nội bộ hiệu quả.'
    },
    {
      icon: Award,
      title: 'Vận động viên',
      description: 'Theo dõi thành tích, lịch thi đấu, thông báo và xếp hạng theo thời gian thực.'
    },
    {
      icon: Scale,
      title: 'Trọng tài/giám sát',
      description: 'Nhập kết quả, xác nhận trận đấu và đảm bảo tính công bằng chuẩn xác.'
    },
  ]

  return (
    <section id="use-cases" className="py-20 bg-gradient-to-b from-neutral-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-mebi-yellow-100 rounded-full mb-6">
              <Building2 className="w-4 h-4 text-mebi-yellow-600 mr-2" />
              <span className="text-sm font-medium text-mebi-yellow-700">Tình huống sử dụng</span>
            </div>
            <h2 className="text-3xl lg:text-5xl font-bold text-neutral-900 mb-4">
              Phù hợp cho mọi đối tượng
            </h2>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Từ ban tổ chức, câu lạc bộ đến vận động viên — MeBi giúp tối ưu quy trình và trải nghiệm.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {cases.map((c, i) => {
              const Icon = c.icon
              return (
                <div key={i} className="group relative bg-white rounded-2xl p-6 border border-neutral-200 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1">
                  <div className="w-14 h-14 bg-mebi-yellow-500 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-neutral-900 mb-2">{c.title}</h3>
                  <p className="text-neutral-600 text-sm">{c.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}